import { Form } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

import { ContractFlowType } from 'modules/contracts/components/FlowPage'

const isEmpty = (array: string[]) => array.length === 0

export const stepHasErrors = (form: Form, type: ContractFlowType) => {
  const catalogLevelErrors = getCatalogLevelErrors(form)
  const salaryErrors = getSalaryErrors(form)

  return !isEmpty(catalogLevelErrors) || !isEmpty(salaryErrors) || !canContinue(form, type)
}

const canContinue = (form: Form, type: ContractFlowType): boolean => {
  /**
   * When type is 'promote' this step is the last
   * Ensure that there are more changes than just the effective on date to unblock the save button.
   * TODO: Product need to define how to show this error, by the moment just blocking next button.
   */
  if (type !== 'promote') return true

  return !!form.dirtyFieldsKeys.find((key) => key !== 'effective_on')
}

const getCatalogLevelErrors = (form: Form): string[] => {
  const errors: string[] = []

  const roleId = form.get('job_catalog_role_id').value
  const levelId = form.get('job_catalog_level_id').value

  if (roleId && !levelId) errors.push(i18n.t('contract_versions.flows.fix.errors.mandatory'))

  form.get('job_catalog_level_id').setErrors(errors)
  return errors
}

const getSalaryErrors = (form: Form): string[] => {
  if (!form.has('salary_amount') || !form.has('salary_frequency')) return []

  const amountErrors: string[] = []
  const frequencyErrors: string[] = []

  const amount = form.get('salary_amount').value
  const frequency = form.get('salary_frequency').value

  if (frequency && !amount)
    amountErrors.push(
      i18n.t('contract_versions.flows.fix.steps.role_level_salary.errors.missing_amount')
    )
  if (!frequency && amount)
    frequencyErrors.push(i18n.t('contract_versions.flows.fix.errors.mandatory'))

  form.get('salary_amount').setErrors(amountErrors)
  form.get('salary_frequency').setErrors(frequencyErrors)
  return amountErrors.concat(frequencyErrors)
}
